module.exports = __webpack_public_path__ + "static/media/value_education.44697b34.pdf";